import user from './user'
import dom from './dom'
import toast from './toast'

export default {
  user,
  dom,
  toast,
}
